/** Share warming/boarding imports and retain successful modules. A failed
 * browser module-map key cannot be repaired by clearing a JavaScript Promise.
 * A fresh fragment retries the same HTTP resource, without CDN query variants.
 */
export class CachedModuleImport<T> {
  private pending: Promise<T> | null = null;
  private failures = 0;

  public constructor(
    private readonly canonicalURL: string,
    private readonly importModule: (url: string) => Promise<T>,
  ) {}

  public request(): Promise<T> {
    if (this.pending) return this.pending;
    const url = new URL(this.canonicalURL);
    if (this.failures > 0) url.hash = `scrapline-retry-${this.failures}`;
    // Defer the importer so synchronous errors also follow the same lifecycle.
    const request = Promise.resolve().then(() => this.importModule(url.href));
    const pending = request.catch(error => {
      if (this.pending === pending) {
        this.pending = null;
        this.failures++;
      }
      throw error;
    });
    this.pending = pending;
    return pending;
  }
}
